import { isEmpty } from 'lodash'
import { connect, DataItem } from 'scrivito'

import { CountItem } from './CountItem'
import { DocumentFileItem } from './DocumentFileItem'
import { DocumentFolderItem } from './DocumentFolderItem'
import { DocumentDrawer } from '@/Atomic/Widgets/DocumentDrawer'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'
import { useDataItemDrawer } from '@/utils/CRUD/hooks/useDataItemDrawer'

interface DocumentsListProps {
  schema: DataItem
}

export const DocumentsList: React.FC<DocumentsListProps> = connect(
  ({ schema }) => {
    const { documents } = useDocumentContext()
    const folders = documents.filter((d) => d.get('folder'))
    const files = documents.filter((d) => !d.get('folder'))
    const foldersCount = folders.length
    const filesCount = files.length

    const {
      drawerItem,
      setDrawerItem,
      isDrawerOpen,
      openDrawer,
      closeDrawer,
      openDrawerId,
      startInEditMode,
    } = useDataItemDrawer()

    const openFor = (dataItem: DataItem, startInEdit: boolean) => {
      setDrawerItem(dataItem)
      openDrawer(startInEdit)
    }

    const currentIndex = files.findIndex(
      (file) => file.id() === drawerItem?.id(),
    )
    const nextId = currentIndex >= 0 ? files[currentIndex + 1]?.id() : undefined
    const previousId =
      currentIndex >= 0 ? files[currentIndex - 1]?.id() : undefined

    return (
      <>
        {!isEmpty(folders) && (
          <>
            <CountItem isFolder={true} count={foldersCount} />
            {folders.map((f) => (
              <DocumentFolderItem key={f.id()} document={f} schema={schema} />
            ))}
          </>
        )}

        {!isEmpty(files) && (
          <>
            <CountItem isFolder={false} count={filesCount} />
            {files.map((f) => (
              <DocumentFileItem
                key={f.id()}
                document={f}
                schema={schema}
                onOpenDrawer={openFor}
              />
            ))}
          </>
        )}
        {drawerItem && (
          <DocumentDrawer
            document={drawerItem}
            isOpen={isDrawerOpen}
            close={closeDrawer}
            startInEditMode={startInEditMode}
            openDrawerId={openDrawerId}
            nextId={nextId}
            previousId={previousId}
          />
        )}
      </>
    )
  },
)
